import React, {useState} from 'react';
import {Container, WriteMessageContainer, WriteMessageInput, SendButton, ImojiIcon, SendIcon} from "./chat-body.styles";
import Picker from 'emoji-picker-react';

const ChatBody = ({children, onSendMessage, inputPlaceholder, chatBodyRef, openInMobile = false, isWritingMessage = true}) => {

    const [emoji, setEmoji] = useState(false);
    const [message, setMessage] = useState('');

    const onEmojiClick = (event, emojiObject) => {
        setMessage(prevValue => prevValue + emojiObject.emoji);
    };

    const changeHandler = ({target: {value}}) => {
        setMessage(value)
    }

    const sendMessage = () => {
        onSendMessage(message);
        setMessage('');
    }

    return (
        <Container className='d-flex flex-column' openInMobile={openInMobile} ref={chatBodyRef}>
            {children}
            {
                isWritingMessage &&
                <WriteMessageContainer className='d-flex align-items-baseline lng-dir'>
                    <Picker onEmojiClick={onEmojiClick}
                            pickerStyle={{
                                display: emoji ? '' : 'none',
                                width: '100%',
                                position: 'absolute',
                                bottom: '70px',
                                right: 0
                            }}/>

                    <SendButton className='d-flex align-items-center justify-content-center' onClick={sendMessage}>
                        <SendIcon className="fas fa-paper-plane"/>
                    </SendButton>
                    <button className='mx-2 simple-btn' onClick={() => setEmoji(prevState => !prevState)}>
                        <ImojiIcon className="far fa-smile main-text-color"/>
                    </button>
                    <WriteMessageInput className='d-flex align-items-center'
                                       value={message}
                                       onChange={changeHandler}
                                       placeholder={inputPlaceholder}>
                    </WriteMessageInput>
                </WriteMessageContainer>
            }
        </Container>
    );
};

export default ChatBody;
